import React, { useState } from 'react';
import { Modal } from './Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="w-full py-8 px-4 bg-navy-light border-t border-gold/10" data-id="element-1">
        <div className="max-w-4xl mx-auto text-center" data-id="element-2">
          <p className="text-gray-400 text-sm mb-3" data-id="element-3">
            © 2026 Sistema de Optimización Crediticia. Todos los derechos
            reservados.
          </p>

          <div className="flex items-center justify-center gap-4 mb-3" data-id="element-4">
            <button onClick={() => setShowPrivacy(true)} className="text-gold-light hover:text-gold text-sm underline transition-colors" data-id="element-5">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-6">•</span>
            <button onClick={() => setShowTerms(true)} className="text-gold-light hover:text-gold text-sm underline transition-colors" data-id="element-7">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-gray-500 text-xs" data-id="element-8">
            Este producto es una guía educativa. Los resultados pueden variar
            según tu situación crediticia individual.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-9">
        <div className="space-y-4 text-gray-300" data-id="element-10">
          <p className="text-sm text-gray-400" data-id="element-11">
            Última actualización: {new Date().toLocaleDateString('es-ES')}
          </p>

          <section data-id="element-12">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-13">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-14">
              Recopilamos información que nos proporcionas directamente al
              adquirir nuestro manual de optimización crediticia, incluyendo:
            </p>
            <ul className="list-disc list-inside ml-4 mt-2 space-y-1" data-id="element-15">
              <li data-id="element-16">Nombre y dirección de correo electrónico</li>
              <li data-id="element-17">Información de pago (procesada de forma segura)</li>
              <li data-id="element-18">Datos de uso del producto digital</li>
            </ul>
          </section>

          <section data-id="element-19">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-20">
              2. Uso de la Información
            </h3>
            <p data-id="element-21">Utilizamos tu información para:</p>
            <ul className="list-disc list-inside ml-4 mt-2 space-y-1" data-id="element-22">
              <li data-id="element-23">Procesar tu compra y entregarte el producto</li>
              <li data-id="element-24">
                Enviarte actualizaciones del manual cuando mejoremos el
                contenido
              </li>
              <li data-id="element-25">Proporcionar soporte al cliente</li>
              <li data-id="element-26">Mejorar nuestros productos y servicios</li>
            </ul>
          </section>

          <section data-id="element-27">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-28">
              3. Protección de Datos
            </h3>
            <p data-id="element-29">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger tu información personal contra acceso no autorizado,
              pérdida o alteración.
            </p>
          </section>

          <section data-id="element-30">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-31">
              4. Compartir Información
            </h3>
            <p data-id="element-32">
              No vendemos ni compartimos tu información personal con terceros,
              excepto cuando sea necesario para procesar pagos o cumplir con
              obligaciones legales.
            </p>
          </section>

          <section data-id="element-33">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-34">
              5. Tus Derechos
            </h3>
            <p data-id="element-35">Tienes derecho a:</p>
            <ul className="list-disc list-inside ml-4 mt-2 space-y-1" data-id="element-36">
              <li data-id="element-37">Acceder a tu información personal</li>
              <li data-id="element-38">Solicitar corrección de datos inexactos</li>
              <li data-id="element-39">Solicitar la eliminación de tus datos</li>
              <li data-id="element-40">Retirar tu consentimiento en cualquier momento</li>
            </ul>
          </section>

          <section data-id="element-41">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-42">
              6. Cookies
            </h3>
            <p data-id="element-43">
              Utilizamos cookies esenciales para el funcionamiento del sitio web
              y para mejorar tu experiencia de usuario.
            </p>
          </section>

          <section data-id="element-44">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-45">
              7. Contacto
            </h3>
            <p data-id="element-46">
              Si tienes preguntas sobre esta política de privacidad, puedes
              contactarnos a través de los canales proporcionados en tu compra.
            </p>
          </section>
        </div>
      </Modal>

      {/* Terms and Conditions Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-47">
        <div className="space-y-4 text-gray-300" data-id="element-48">
          <p className="text-sm text-gray-400" data-id="element-49">
            Última actualización: {new Date().toLocaleDateString('es-ES')}
          </p>

          <section data-id="element-50">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-51">
              1. Aceptación de Términos
            </h3>
            <p data-id="element-52">
              Al adquirir y utilizar el Sistema de Optimización Crediticia,
              aceptas estos términos y condiciones en su totalidad. Si no estás
              de acuerdo, no debes utilizar este producto.
            </p>
          </section>

          <section data-id="element-53">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-54">
              2. Descripción del Producto
            </h3>
            <p data-id="element-55">
              Este producto es un manual educativo digital en formato PDF que
              proporciona información y estrategias para la optimización
              crediticia. Incluye:
            </p>
            <ul className="list-disc list-inside ml-4 mt-2 space-y-1" data-id="element-56">
              <li data-id="element-57">Guía paso a paso para mejorar tu credit score</li>
              <li data-id="element-58">Plantillas y recursos descargables</li>
              <li data-id="element-59">Acceso de por vida al contenido</li>
              <li data-id="element-60">Actualizaciones futuras sin costo adicional</li>
            </ul>
          </section>

          <section data-id="element-61">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-62">
              3. Licencia de Uso
            </h3>
            <p data-id="element-63">
              Se te otorga una licencia personal, no transferible y no exclusiva
              para usar este manual. No puedes:
            </p>
            <ul className="list-disc list-inside ml-4 mt-2 space-y-1" data-id="element-64">
              <li data-id="element-65">Revender, redistribuir o compartir el contenido</li>
              <li data-id="element-66">Modificar o crear trabajos derivados</li>
              <li data-id="element-67">Usar el contenido con fines comerciales sin autorización</li>
            </ul>
          </section>

          <section data-id="element-68">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-69">
              4. Descargo de Responsabilidad
            </h3>
            <p className="font-semibold text-gold-light mb-2" data-id="element-70">
              IMPORTANTE: Este es un producto educativo.
            </p>
            <ul className="list-disc list-inside ml-4 space-y-1" data-id="element-71">
              <li data-id="element-72">No garantizamos resultados específicos en tu credit score</li>
              <li data-id="element-73">
                Los resultados varían según tu situación crediticia individual
              </li>
              <li data-id="element-74">
                No somos asesores financieros ni ofrecemos servicios de
                reparación de crédito
              </li>
              <li data-id="element-75">
                La información proporcionada es de naturaleza educativa general
              </li>
            </ul>
          </section>

          <section data-id="element-76">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-77">
              5. Política de Reembolso
            </h3>
            <p data-id="element-78">
              Debido a la naturaleza digital del producto y el acceso inmediato
              al contenido, todas las ventas son finales. No ofrecemos
              reembolsos una vez que el producto ha sido descargado o accedido.
            </p>
          </section>

          <section data-id="element-79">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-80">
              6. Propiedad Intelectual
            </h3>
            <p data-id="element-81">
              Todo el contenido, incluyendo texto, gráficos, logos y software,
              es propiedad exclusiva de Sistema de Optimización Crediticia y
              está protegido por leyes de derechos de autor.
            </p>
          </section>

          <section data-id="element-82">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-83">
              7. Limitación de Responsabilidad
            </h3>
            <p data-id="element-84">
              No seremos responsables por daños directos, indirectos,
              incidentales o consecuentes que resulten del uso o la
              imposibilidad de usar este producto.
            </p>
          </section>

          <section data-id="element-85">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-86">
              8. Modificaciones
            </h3>
            <p data-id="element-87">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Los cambios entrarán en vigor inmediatamente después de
              su publicación.
            </p>
          </section>

          <section data-id="element-88">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-89">
              9. Ley Aplicable
            </h3>
            <p data-id="element-90">
              Estos términos se rigen por las leyes de los Estados Unidos.
              Cualquier disputa se resolverá en los tribunales competentes.
            </p>
          </section>

          <section data-id="element-91">
            <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-92">
              10. Contacto
            </h3>
            <p data-id="element-93">
              Para preguntas sobre estos términos, contacta a través de los
              canales proporcionados en tu compra.
            </p>
          </section>
        </div>
      </Modal>
    </>;
}